export default {"src":"/_next/static/media/LXP.5e12555b.svg","height":18,"width":18};